<template>
  <div class="aselect" :data-value="selected" :data-list="optionsList">
    <div
      class="selector"
      @click="toggle"
      @keydown="handleKeydown"
      :class="{ disabled: isDisabled }"
      tabindex="0"
    >
      <div class="label" :class="{ 'text-disabled': isDisabled, 'text-enabled': !isDisabled }">
        <span>{{ selectedText }}</span>
      </div>
      <div class="arrow" :class="{ expanded: isOpen }"></div>
      <div :class="{ hidden: !isOpen, visible: isOpen }">
        <ul>
          <li
            :class="{ current: option.value === selected }"
            v-for="option in optionsList"
            :key="option.key"
            @mousedown.stop="select(option.value)"
          >
          <div v-if="option.img" class="option-content">
              <img :src="option.img" alt="option image" class="option-image" />
              <span>{{ option.text }}</span>
            </div>
            <span v-else>{{ option.text }}</span>
          </li>
        </ul>
      </div>
    </div>
    <input type="hidden" :name="name" :value="selected" />
  </div>
</template>

<script>
export default {
  name: 'CustomSelect',
  props: {
    value: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Seleziona',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.value,
      searchLetter: '',
    };
  },
  computed: {
    optionsList() {
      return this.options.map((option, index) => ({
        key: index,
        value: option.value,
        text: option.text,
        img: option.img,
      }));
    },
    selectedText() {
      const selectedOption = this.optionsList.find(option => option.value === this.selected);
      return selectedOption ? selectedOption.text : this.placeholder;
    },
    isDisabled() {
      return this.disabled || this.optionsList.length === 0;
    },
  },
  methods: {
    toggle() {
      if (!this.isDisabled) {
        this.$emit('toggle');
      }
    },
    select(value) {
      this.selected = value;
      this.$emit('input', value);
      this.$emit('change', this.name);
      this.$emit('toggle');
    },
    handleKeydown(event) {
            if (this.isOpen) {
                if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
                    // Aggiungi il carattere digitato a searchTerm
                    this.searchTerm += event.key.toLowerCase();

                    // Resetta il timeout precedente se esiste
                    if (this.searchTimeout) {
                        clearTimeout(this.searchTimeout);
                    }

                    // Imposta un timeout per resettare searchTerm dopo 500ms di inattività
                    this.searchTimeout = setTimeout(() => {
                        this.searchTerm = '';
                        this.searchTimeout = null;
                    }, 500);

                    // Trova l'indice dell'opzione che corrisponde a searchTerm
                    const optionIndex = this.optionsList.findIndex(option =>
                        option.text.toLowerCase().startsWith(this.searchTerm)
                    );

                    if (optionIndex !== -1) {
                        this.scrollToOption(optionIndex);
                    }
                } else if (event.key === 'Backspace') {
                    // Rimuovi l'ultimo carattere da searchTerm
                    this.searchTerm = this.searchTerm.slice(0, -1);

                    // Resetta il timeout precedente se esiste
                    if (this.searchTimeout) {
                        clearTimeout(this.searchTimeout);
                    }

                    // Imposta un timeout per resettare searchTerm dopo 500ms di inattività
                    this.searchTimeout = setTimeout(() => {
                        this.searchTerm = '';
                        this.searchTimeout = null;
                    }, 500);

                    // Trova l'indice dell'opzione che corrisponde a searchTerm
                    const optionIndex = this.optionsList.findIndex(option =>
                        option.text.toLowerCase().startsWith(this.searchTerm)
                    );

                    if (optionIndex !== -1) {
                        this.scrollToOption(optionIndex);
                    }
                } else if (event.key === 'Escape') {
                    // Chiudi la select
                    this.$emit('toggle');
                }
            }
        },
    scrollToOption(index) {
      this.$nextTick(() => {
        const optionsContainer = this.$el.querySelector('ul');
        const optionElement = optionsContainer.children[index];

        if (optionElement) {
          optionsContainer.scrollTop = optionElement.offsetTop - optionsContainer.offsetTop;
        }
      });
    },
  },
  watch: {
    value(newValue) {
      this.selected = newValue;
    },
  },
};
</script>

<style scoped>
.aselect {
  width: 320px;
}
.selector {
  border: 1px solid #b1b1b1;
  border-radius: 4px;
  background: #ffffff;
  position: relative;
  cursor: pointer;
  outline: none;
}
.selector.disabled {
  background: white;
  cursor: not-allowed;
}
.arrow {
  position: absolute;
  right: 10px;
  top: 15px;
  width: 18px;
  height: 10px;
  background: url('../../../images/project-img/Arrow-Small-down.png') no-repeat center;
  background-size: contain;
  transform: rotateZ(0deg) translateY(0px);
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.59, 1.39, 0.37, 1.01);
}
.expanded {
  transform: rotateZ(180deg) translateY(2px);
}
.label {
  display: block;
  padding: 12px;
  font-size: 14px;
}
.text-disabled {
  color: #b1b1b1;
}
.text-enabled {
  color: black;
}
ul {
  width: 100%;
  list-style-type: none;
  padding: 0;
  margin: 0;
  font-size: 14px;
  border: 1px solid #b1b1b1;
  position: absolute;
  z-index: 10;
  background: #fff;
  overflow: auto;
  max-height: 200px;
}
li {
  padding: 12px;
  color: #666;
}
li:hover {
  color: white;
  background: #b1b1b1;
}
.current {
  background: #eaeaea;
}
.hidden {
  visibility: hidden;
}
.visible {
  visibility: visible;
}
.option-content {
  display: flex;
  align-items: center;
}

.option-image {
  width: 60px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/CustomSelect.vue